import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';

import { PaypalResponse } from '../models/response-paypal.model';

declare let paypal: any;

@Component({
  selector: 'paypal-new-form-pay',
  templateUrl: './paypal-new.component.html',
  styleUrls: ['./paypal-new.component.scss']
})
export class PayPalNewComponent implements OnInit, AfterViewChecked {
  @Input() accessToken: string;
  @Input() clientId: string;
  @Input() vkUrlApi: string;
  @Input() storeId: string;
  @Input() userId: string;
  @Input() transactionId: string;
  @Input() amount: string;
  @Input() currency: string;
  @Input() cancelUrl: string;
  @Input() successUrl: string;
  @Input() data: string;
  @Input() urlSignout: string;

  private addScript = false;

  errorsMessage: any;

  showError = false;
  loading = true;
  status = '';
  linkToPay = '';
  linkExecutePay = '';

  constructor() {
    // if (this.urlSignout === '') {
    //   const wnd = window.open(this.urlSignout, 'myWindow', 'width=100,height=100');
    //   setTimeout(function () { wnd.close(); }, 1000);
    // }
  }

  ngOnInit(): void {

  }

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {

        const paypalConfig = {
          style: {
            color: 'blue',
            shape: 'pill',
            label: 'pay',
            height: 40
          },
          commit: true,
          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [{
                amount: { value: (<HTMLInputElement>document.getElementById('amount')).value },
                reference_id: '\'' + (<HTMLInputElement>document.getElementById('transactionId')).value + '\'',
                custom_id: '\'' + (<HTMLInputElement>document.getElementById('storeId')).value + '\''
              }],
              application_context: {
                shipping_preference: 'NO_SHIPPING'
              }
            });
          },

          // Finalize the transaction
          onApprove: function (data, actions) {
            return actions.order.capture().then(function (details: PaypalResponse) {
              details.data = (<HTMLInputElement>document.getElementById('data')).value;
              details.userid = (<HTMLInputElement>document.getElementById('userId')).value;

              fetch((<HTMLInputElement>document.getElementById('vkUrlApi')).value, {
                method: 'post',
                headers: {
                  'content-type': 'application/json',
                  'Authorization': 'Bearer ' + (<HTMLInputElement>document.getElementById('accessToken')).value
                },
                body: JSON.stringify({ details })
              }).then((response) => {
                console.log('response-> api', response);
              }).then(() => {
                window.location.href = (<HTMLInputElement>document.getElementById('successUrl')).value;
              });
            });
          },
          onError: function (error) {
            window.location.reload();
          },
          onCancel: (data, actions) => {
            window.location.href = (<HTMLInputElement>document.getElementById('cancelUrl')).value;
          }
        };

        paypal.Buttons(paypalConfig).render('#paypal-button-container');
        this.loading = false;
      });
    }
  }

  private addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement('script');
      scripttagElement.src = `https://www.paypal.com/sdk/js?client-id=${this.clientId}&currency=${this.currency}`;
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }
}
